import { useEffect } from 'react';
import { useSetState } from 'minimal-shared/hooks';
import Stack from '@mui/material/Stack';
import ButtonBase from '@mui/material/ButtonBase';
import { useRouter } from 'src/routes/hooks';
import { fShortenNumber } from 'src/utils/format-number';
import { useTranslate } from 'src/locales';
import { getData, updateData, createBatch } from 'src/lib/firebase';
import { toast } from 'src/components/snackbar';
import { Iconify } from 'src/components/iconify';
import { useRedirectToSignIn } from 'src/auth/hooks';

// ----------------------------------------------------------------------

export function ButtonsLike({
  uid,
  path,
  totalLikes = 0,
  totalDislikes = 0,
  sx,
  ...other
}) {
  const router = useRouter();
  const {
    t
  } = useTranslate();
  const urlToSignIn = useRedirectToSignIn();
  const {
    state,
    setState
  } = useSetState({
    totalLikes,
    totalDislikes,
    isLike: false,
    isDislike: false
  });
  const handleToggleLike = async type => {
    if (!uid) {
      router.push(urlToSignIn);
      return;
    }
    const currentState = state;
    const isLikeAction = type === 'like';
    const isLike = isLikeAction ? !currentState.isLike : currentState.isLike;
    const isDislike = !isLikeAction ? !currentState.isDislike : currentState.isDislike;
    const total_Likes = currentState.totalLikes + (isLikeAction ? isLike ? 1 : -1 : isLike ? -1 : 0);
    const total_Dislikes = currentState.totalDislikes + (!isLikeAction ? isDislike ? 1 : -1 : isDislike ? -1 : 0);
    const is_Like = isDislike ? false : isLike;
    const is_Dislike = isLike ? false : isDislike;
    setState({
      isLike: is_Like,
      isDislike: is_Dislike,
      totalLikes: total_Likes,
      totalDislikes: total_Dislikes
    });
    try {
      const batch = createBatch();
      updateData(`${path}/likes/${uid}`, {
        isLike: is_Like,
        isDislike: is_Dislike
      }, batch);
      updateData(path, {
        totalLikes: total_Likes,
        totalDislikes: total_Dislikes
      }, batch);
      await batch.commit();
    } catch (error) {
      console.error(error);
      toast.error(`${t('An error occurred')}, ${t('please try again')}`);
      setState(currentState);
    }
  };
  const fetchLikes = async () => {
    const {
      isLike = false,
      isDislike = false
    } = await getData({
      path: `${path}/likes/${uid}`
    });
    setState({
      isLike,
      isDislike,
      totalLikes,
      totalDislikes
    });
  };
  useEffect(() => {
    if (uid) fetchLikes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid]);
  return <Stack spacing={2} direction="row" sx={[{
    pt: 1.5
  }, ...(Array.isArray(sx) ? sx : [sx])]} {...other}>
      {[{
      icon: 'like',
      active: state.isLike
    }, {
      icon: 'dislike',
      active: state.isDislike
    }].map((item, index) => <ButtonBase key={index} disableRipple onClick={() => handleToggleLike(item.icon)} sx={{
      gap: 0.5,
      typography: 'caption'
    }}>
          <Iconify icon={`solar:${item.icon}-${item.active ? 'bold' : 'outline'}`} width={16} />
          {fShortenNumber(state[item.icon === 'like' ? 'totalLikes' : 'totalDislikes'])}
        </ButtonBase>)}
    </Stack>;
}